import { createQueryKeyStore } from '@lukemorales/query-key-factory';

export const NAICS_CODE_QUERY_KEY = createQueryKeyStore({
	naicsCodes: {
		list: () => ['naics-codes'],
		formattedList: () => ['naics-codes-formatted'],
	},
});
